export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/applause-icon.png?f4925efc152c51192b1a2cc8f7b8b803";